import React from "react"

const MD_LINK = /\[([^\]]+)\]\(([^)]+)\)/g

export function AiContent({ text }: { text: string }) {
  const parts: React.ReactNode[] = []
  let lastIndex = 0
  let key = 0

  let match: RegExpExecArray | null
  MD_LINK.lastIndex = 0
  while ((match = MD_LINK.exec(text)) !== null) {
    const [full, label, href] = match
    const idx = match.index
    if (idx > lastIndex) {
      parts.push(text.slice(lastIndex, idx))
    }
    const isInternal = href.startsWith("/") || href.includes("kvatronix.in.ua")
    parts.push(
      <a
        key={`l-${key++}`}
        href={href}
        target={isInternal ? undefined : "_blank"}
        rel={isInternal ? undefined : "noopener noreferrer"}
        className="font-medium text-brand-light underline-offset-2 hover:underline dark:text-brand-dark"
      >
        {label}
      </a>
    )
    lastIndex = idx + full.length
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return <>{parts}</>
}
